/**
 * Turbo Setup
 * Configures Turbo Drive and Turbo Streams for the WWW site
 */

import { Turbo } from '@hotwired/turbo-rails';
import TurboPower from 'turbo_power';

// Start Turbo Drive
Turbo.start();

// Disable prefetch on hover - we don't want eager loading of links
Turbo.config.drive.preloadOnHover = false;

// Initialize TurboPower for additional Turbo Stream actions
TurboPower.initialize(Turbo.StreamActions);

// Import custom Bootstrap modal Turbo Stream actions
import '../../../../app/javascript/turbo_stream_actions';

/**
 * Clean up before Turbo caches the page
 * This prevents stale DOM state from being cached and restored incorrectly
 *
 * NOTE: Navbar cleanup is handled by navbar_controller.js via turbo:before-cache.
 * This handler only cleans up other elements like product pages, tooltips, and popovers.
 */
document.addEventListener('turbo:before-cache', () => {
  // Clear product page state flags (these are still used by product-page controller)
  const productElements = document.querySelectorAll(
    '[data-product-page-loaded], [data-product-page-loading]'
  );
  productElements.forEach(el => {
    delete el.dataset.productPageLoaded;
    delete el.dataset.productPageLoading;
  });

  // Dispose tooltips and popovers (these are created programmatically by Bootstrap)
  if (window.bootstrap) {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
      const instance = window.bootstrap.Tooltip.getInstance(el);
      if (instance) {
        instance.hide();
        instance.dispose();
      }
    });

    document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => {
      const instance = window.bootstrap.Popover.getInstance(el);
      if (instance) {
        instance.hide();
        instance.dispose();
      }
    });
  }
});

// NOTE: Removed custom popstate listener that was fighting with Turbo Drive.
// Turbo already handles back/forward navigation. If product facets need special
// handling, use Turbo Frames with data-turbo-action="advance" instead.

export { Turbo };

